module.exports = __webpack_public_path__ + "static/media/nb4.b25bd8bd.jpg";